import React from 'react'
import { getAssetUrl } from '../../helper/BaseUrl'


export default function DynamicPageSmart({ data }) {
  if (!data?.title) return null;
  const sectionImageUrl = getAssetUrl(data?.second_section_image);
  return (
    <>

      <section className="human-smart-area">
        <div className="container">
          <div className="row justify-content-between align-items-center">
            <div className="col-lg-5 col-md-6 order-md-0 " >
              <div className="human-smart-content">
                <small>{data?.second_section_subtitle}</small>
                <h3 className="heading">{data?.second_section_title}</h3>
                <div dangerouslySetInnerHTML={{ __html: data?.second_section_description }} />
              </div>
            </div>
            <div className="col-lg-6 col-md-6 wow animate__animated animate__zoomIn order-md-1" data-wow-duration="0.6s" data-wow-delay="0s">
              <div className="human-smart-image">
                {sectionImageUrl && <img src={sectionImageUrl} alt={data?.second_section_image_alt || data?.second_section_title || "Section"} />}
              </div>
            </div>
          </div>
        </div>
      </section>

    </>
  )
}
